/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useContext} from 'react'

import Context from '@s-ui/react-context'

const useFilter = ({search, type}) => {
  const {domain, i18n} = useContext(Context)

  const config = domain.get('config')

  const {FILTERS_HELP_TEXTS} = config.get('filtersHelpTexts')
  const {FILTER_NAMES} = config.get('searchFilters')
  const {FILTERS_OPTIONS} = config.get('filtersOptions')
  const {FILTERS_PLACEHOLDERS} = config.get('filtersPlaceholders')

  const toHours = minutes => {
    if (typeof minutes !== 'number' || isNaN(minutes)) return undefined
    return Math.floor(minutes / 60)
  }

  const getValue = useCallback(() => {
    const electricChargingFastModeValue = search[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].to
    const electricChargingStandardModeValue = toHours(search[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].to)

    return {
      [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: electricChargingFastModeValue
        ? [electricChargingFastModeValue]
        : [],
      [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: electricChargingStandardModeValue
        ? [electricChargingStandardModeValue]
        : []
    }
  }, [search])

  const getFilters = useCallback(() => {
    const {
      [FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]: [electricChargingFastModeValue],
      [FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]: [electricChargingStandardModeValue]
    } = getValue()

    return [
      {
        allSelectionsLabel: i18n.t(FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].to),
        helpText: i18n.t(FILTERS_HELP_TEXTS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE]),
        label: i18n.t('FILTERS.ELECTRIC_CHARGING_TIME_FAST_MODE.PLACEHOLDER'),
        name: FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE,
        options: FILTERS_OPTIONS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].map(option => ({
          id: option,
          label: `${i18n.t(FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].to)} ${option} ${i18n.t(
            'COMMON.PLURALS.MINUTE',
            option
          )}`
        })),
        placeholder: electricChargingFastModeValue
          ? `${i18n.t(
              FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].to
            )} ${electricChargingFastModeValue} ${i18n.t('COMMON.PLURALS.MINUTE', electricChargingFastModeValue)}`
          : i18n.t(FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_FAST_MODE].to),
        type
      },
      {
        allSelectionsLabel: i18n.t(FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].to),
        helpText: i18n.t(FILTERS_HELP_TEXTS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE]),
        label: i18n.t('FILTERS.ELECTRIC_CHARGING_TIME_STANDARD_MODE.PLACEHOLDER'),
        name: FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE,
        options: FILTERS_OPTIONS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].map(option => ({
          id: option,
          label: `${i18n.t(FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].to)} ${toHours(
            option
          )} ${i18n.t('COMMON.PLURALS.HOUR', toHours(option))}`
        })),
        placeholder: electricChargingStandardModeValue
          ? `${i18n.t(
              FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].to
            )} ${electricChargingStandardModeValue} ${i18n.t('COMMON.PLURALS.HOUR', electricChargingStandardModeValue)}`
          : i18n.t(FILTERS_PLACEHOLDERS[FILTER_NAMES.ELECTRIC_CHARGING_TIME_STANDARD_MODE].to),
        type
      }
    ]
  }, [search, type])
  return {filters: getFilters(), value: getValue()}
}

export default useFilter
